var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgUndo = function SvgUndo(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 13.2856C20 8.88564 16.4 5.28564 12 5.28564C9.8 5.28564 7.8 6.28564 6 7.28564L4 5.28564V12.2856L11 12.2856L8 9.28564C8.9 7.98564 10.3 7.28564 12 7.28564C15.3 7.28564 18 9.98564 18 13.2856C18 14.8492 17.3939 16.278 16.4051 17.3488L17.863 18.7145C19.1876 17.2855 20 15.3758 20 13.2856Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUndo);
export default ForwardRef;